define(function(require,exports,module){
    var DeviceInteraction = require( "./DeviceInteraction" );
    var parseUrl = require( "app-url/app-url" );

    var SEP = "&";
    var STRING = "string";
    var NUMBER = "number";

    /**
     * IOS Interaction schema : 
     *          Safari (webview?)
     *     json = {
     *         "safariurl":url 
     *     }
     *         native video
     *     json = {
     *         "videourl" : url
     *         "mediaid"  : cid         
     *     }
     */

    function extend(target, source){
        var key;
        for(key in source){
            target[key] = source[key];
        }
        return target;
    }

    function isStringish(maybeStringOrNumber) {
        return typeof maybeStringOrNumber === STRING || typeof maybeStringOrNumber === NUMBER;
    }

    function ensureString(thing){
        return isStringish(thing) ? thing : encodeURIComponent(JSON.stringify(thing));
    }

    function IOSDispatcher(options){
        this.url = parseUrl();
        this.params = this.url.hashParams;
        this.deepLinkPrefix = options.deepLinkPrefix;
        if(this.params.json){
            this.params.json = decodeURIComponent(JSON.parse(this.params.json));
        }
    }

    IOSDispatcher.prototype.buildHash = function(){
        var key,
            ret = [],
            params = this.params;

        for (key in params) {
            ret.push(key + '=' + ensureString(params[key]));
        }

        this.url.setProperty('hash',ret.join(SEP))
        return this.url.hash;
    };

    IOSDispatcher.prototype.mergeKeys = function(params){
        if(params.json){
            params.json.timestamp = (new Date()).getTime();
        }
        this.url.setProperty('hash',location.hash);
        return this.params=extend(this.url.hashParams,params);
    };

    IOSDispatcher.prototype.publish = function(params){
        this.url = parseUrl();
        this.mergeKeys(params);
        this.buildHash();
        window.location.replace(this.url.toString());
    }

    IOSDispatcher.prototype.buildLink = function(params){
        
        if (!this.deepLinkPrefix) {
            return false;
        }

        var prefix = this.deepLinkPrefix;
        var paramsConfig = params.queries;
        var type = params.type
        var query = Object.keys(paramsConfig).map(function(k) {
            return k + '=' + paramsConfig[k];
        }).join('&');
        return prefix + '://' + type + '?'+ query;
    };

    IOSDispatcher.prototype.link = function(params){
        const deeplinkUrl = this.buildLink(params);
        if (deeplinkUrl) {
            window.location.replace(this.buildLink(params));
        }
    }

    function IOSInteraction(options){
        this.dispatcher = new IOSDispatcher({
            deepLinkPrefix: options.deepLinkPrefix || this.deepLinkPrefix
        });
        IOSInteraction.superclass.constructor.call(this);
    }

    IOSInteraction.isDispatcherAvailable = /iP(?:hone|ad|od)/.test(navigator.userAgent);

    DeviceInteraction.spawn(IOSInteraction)
        .define({
            type    : "ios",
            deepLinkPrefix : 'mlbatbat',
            video   : function(data){
                var baseData = {
                        "videourl": data.url, 
                        "mediaid": data.vid || data.id,
                        "title": data.title|| data.headline
                    };
                if (typeof data.authflow !== "undefined") {
                	baseData["authFlow"] = (data.authflow === true);
                }    
                this.dispatcher.publish({
                    "json" : baseData
                });
                return true;
            },
            track   : function(data){
                this.dispatcher.publish({
                    "json" : {
                        "gid": data.gid, 
                        "view": data.view,
                        "detail": data.detail
                    }
                });
                return true;
            },
            photo   : function(data){
                this.dispatcher.publish({
                    "json" : {
                        "id": data.id
                    }
                });
                return true;
            },
            webview : function(data){
                this.dispatcher.publish({
                    "json" : {
                        safariurl : data.url
                    }
                });
                return true;
            },
            playercard : function(data){
                switch (this.dispatcher.deepLinkPrefix) {
                    case 'milbfirstpitch':
                        this.milbplayercard(data);
                        break;
                    default:
                        this.mlbplayercard(data);
                }
                return true;
            },
            mlbplayercard : function(data){
                this.dispatcher.publish({
                    "json" : {
                        playerId    : data.playerId || data.pid,
                        playerCard  : true,
                        playerString: data.name || data.title 
                    }
                });
                return true;
            },
            milbplayercard : function(data){
                this.dispatcher.link({
                    queries: {
                        "player_id" : data.playerId || data.pid
                    },
                    type  : 'athlete'
                });
                return true;
            },
            openArticle: function(data){
                this.dispatcher.link({
                    queries: {
                        "article" : data.contentId || ''
                    },
                    type: 'news'
                });
                return true;
            },
            share : function(data){
               this.dispatcher.publish({
                    "json" : {
                        "videourl": data.url, 
                        "mediaid": data.vid || data.id,
                        "shareable":true
                    }
                });
                return true;
            },
            articleshare : function(data){
               this.dispatcher.publish({
                    "json" : {
                        "articleurl": data.url, 
                        "id": data.id,
                        "shareable":true
                    }
                });
                return true;
            },
            mlbtv : function(data){
               this.dispatcher.publish({
                    "json" : {
                        "gamedayLink": data.gid, 
                        "contentid": data.feed,
                        "eventid"  : data.feed
                    }
                });
                return true;
            },
            nhltv : function(data){
               this.dispatcher.publish({
                    "json" : {
                        "link": data.gid, 
                        "contentid": data.feed,
                        "eventid"  : data.feed
                    }
                });
                return true;
            },
            milbtv: function(data){
                this.dispatcher.publish({
                     "json" : {
                        "gamedayLink": data.gid, 
                        "contentid": data.feed,
                        "eventid"  : data.feed
                     }
                 });
                 return true;
            },
            audio   : function(data){
                this.dispatcher.publish({
                    "json" : {
                        "mediaid": data.aid || data.id
                    }
                });
                return true;
            },
            isDispatcherActive : function(){
                return IOSInteraction.isDispatcherAvailable && !!this.dispatcher;
            },
            gameday : function(data){
                this.dispatcher.link({
                    queries: {
                        "gamepk" : data.gamePk
                    },
                    type  : 'game'
                });
                return true;
            },
            mlbtvapp : function(data){
                this.dispatcher.link({
                    queries: {
                        "gamepk" : data.gamePk,
                        "date": data.date
                    },
                    type  : 'mlbtv'
                });
                return true;
            },
            milbtvapp : function(data){
                this.dispatcher.link({
                    queries: {
                        "gamepk" : data.gamePk
                    },
                    type  : 'milbtv'
                });
                return true;
            },
            tvapp : function(data){
                switch (this.dispatcher.deepLinkPrefix) {
                    case 'milbfirstpitch':
                        this.milbtvapp(data);
                        break;
                    default:
                        this.mlbtvapp(data);
                }
                return true;
            },
            team : function(data){
                this.dispatcher.link({
                    queries: {
                        "team_id" : data.teamId
                    },
                    type  : 'team'
                });
                return true;
            },
        });
    return IOSInteraction;
});
